export default [
  {
    id: 1,
    name: "Tiger Nixon",
    phone: "02345678",
    city: "Dtac",
    age: "61",
    createdAt: "2011/04/25",
    salary: "$320,800",
    type: "Dtac Admin",
    email: "admin@dtac.com"
  },
  {
    id: 2,
    name: "Garrett Winters",
    phone: "02345678",
    city: "Tokyo",
    age: "63",
    createdAt: "2011/07/25",
    salary: "$170,750",
    type: "Corporate Admin",

    email: "corp@dtac.com"
  },
  {
    id: 3,
    name: "Ashton Cox",
    phone: "023456778",
    city: "Dtac",
    age: "66",
    createdAt: "2009/01/12",
    salary: "$86,000",
    type: "Read Only",

    email: "read@dtac.com"
  },
  {
    id: 4,
    name: "Cedric Kelly",
    phone: "023456778",
    city: "Edinburgh",
    age: "22",
    createdAt: "2012/03/29",
    salary: "$433,060",
    type: "Corporate Admin",

    email: "corp@dtac.com"
  },
];
